import { TimeStamps, UID } from './common';
import type { EducationalUnit } from './educational';
import type { TeritorialUnit } from './teritorial';

export type UserAccessManagement = {
  authorities: string[];
  assetsAccessCategories: string[];
};

export type User = {
  id: UID;
  inicials: string;
  email: string;
  phone?: string;
  langKey: string;
  hash: string;
  firstName?: string;
  lastName?: string;
  sector: Sector;
  createdBy?: User;
  updatedBy?: User;
  activated?: boolean;
  completed?: boolean;

  // municipality | business | educational
  name?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;

  // municipality
  teritorialUnit?: TeritorialUnit;

  // business | educational
  address?: string;

  // business
  companyIn?: string;

  // educational
  educationalUnit: EducationalUnit;
} & UserAccessManagement &
  TimeStamps;

export type Users = User[];

export type UserRole = 'ADMIN' | 'USER' | 'SUBSCRIBER' | 'COMMITTEE' | 'EDITOR';

export const AUTHORITIES = {
  ADMIN: 'ADMIN',
  USER: 'USER',
};

export type Authorities = UserRole[];

export type AuthoritiesObj = {
  isAdmin: boolean;
};

export const SECTORS = [
  'ADMIN',
  'PER',
  'BUS',
  // 'GOV',
  'MUN',
  'EDU',
] as const;
export type Sector = typeof SECTORS[number];
export const SECTORS_OPTIONS = SECTORS.map((value) => ({
  value,
  label: value,
}));
export const PUBLIC_SECTORS_OPTIONS = SECTORS_OPTIONS.filter(
  ({ value }) => value !== 'ADMIN'
);

export const MUTABLE_BY_CLIENT = [
  'inicials',
  'email',
  'langKey',
  'firstName',
  'lastName',
  'sector',

  // municipality | business | educational
  'name',
  'contactName',
  'contactPhone',
  'contactEmail',

  // municipality
  'teritorialUnit',

  // business | educational
  'address',

  // business
  'companyIn',

  // educational
  'educationalUnit',
] as const;

export const CREATABLE_BY_CLIENT = ['email', 'sector', 'langKey'] as const;

export type CreateableByClient = typeof CREATABLE_BY_CLIENT[number];
export type CreateableByClientObj = Pick<User, CreateableByClient>;

export const EMPTY_USER: Partial<User> = {
  sector: 'ADMIN',
};

export const ADMIN_LIST_COLS = [
  'id',
  'activated',
  'sector',
  'authorities',
  'assetsAccessCategories',
  'email',
  'langKey',
  'firstName',
  'lastName',
  'sector',
  'createdBy',
  'updatedBy',
  'createdAt',
  'updatedAt',
];
